<template>
<svg viewBox="0 0 14 14" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-if`]" width="1em" height="1em" v-bind="$attrs"><path d="M3.86328 4.48438C4.6731 4.48438 5.14062 4.97056 5.14062 5.81152V10.3525C5.14062 11.1935 4.6731 11.6729 3.86328 11.6729C3.05353 11.6728 2.58594 11.1935 2.58594 10.3525V5.80566C2.58594 4.96473 3.05353 4.48441 3.86328 4.48438ZM8.88379 2.42285C10.2417 2.42285 10.747 2.83996 10.7471 3.38184C10.7471 3.6933 10.5906 3.87373 10.2979 3.96094C10.192 3.99203 10.0734 4.01099 9.93652 4.02344C9.38868 4.06087 9.19531 4.22963 9.19531 4.54102V4.70215H9.7627C10.2423 4.70221 10.6406 5.01447 10.6406 5.59375C10.6405 6.17281 10.2422 6.49017 9.7627 6.49023H9.27051V10.3525C9.27051 11.2558 8.74069 11.6729 7.99316 11.6729C7.24577 11.6728 6.7168 11.2557 6.7168 10.3525V6.49023H6.56055C6.08103 6.49018 5.68277 6.17282 5.68262 5.59375C5.68262 5.01447 6.08094 4.7022 6.56055 4.70215H6.7168V4.41602C6.71681 3.02081 7.4202 2.44165 8.88379 2.42285ZM3.86328 1.65625C4.58589 1.65625 5.13379 2.18 5.13379 2.86523C5.13365 3.55033 4.58579 4.07324 3.86328 4.07324C3.14082 4.07319 2.59292 3.5503 2.59277 2.86523C2.59277 2.18004 3.14072 1.6563 3.86328 1.65625Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillIf',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
